/**
 * @flow
 */
import {Reducer} from 'redux';
import type {SignUpRequest, SignUpResponse} from '../../types/api-types'
import type {APIAction, APIState} from '../../types/types'
import API from '../../services/API'

export type SignUpActionType = 'SIGN_UP_PENDING' | 'SIGN_UP_DONE' | 'SIGN_UP_ERROR';

export interface SignUpAction extends APIAction<SignUpRequest, SignUpResponse> {
  type: SignUpActionType;
}

export interface SignUpState extends APIState<SignUpRequest, SignUpResponse> {

}

const signUpReducer: Reducer<SignUpState, SignUpAction> = (state = initialSignUpState, action) => API.processAction(state, action, 'SIGN_UP');

const initialSignUpState: SignUpState = {status: ''}

export default signUpReducer;
